import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../openapi';

@Pipe({
  name: 'shipmentContentLabel',
  standalone: true
})
export class ShipmentContentLabelPipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (application?.service?.url) {
      case '/uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego': {
        return 'Czego dotyczy uwaga';
      }
      default:
        return 'Treść pisma';
    }
  }

}
